// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'column-no-right';

export const Component = () => (
  <path d='M18.63.961h5.891V.004H5.316C3.832-.044 2.586.386 1.58 1.297.527 2.063 0 3.117 0 4.41v15.708c0 1.293.527 2.347 1.58 3.114 1.006.91 2.251 1.34 3.736 1.293h19.205v-.958h-5.89V.96h-.001ZM8.812 23.567H5.316A5.7 5.7 0 0 1 2.25 22.56c-.861-.62-1.292-1.435-1.292-2.44V4.411c0-1.006.431-1.82 1.293-2.443.861-.67 1.868-1.005 3.065-1.005h3.496v22.605-.001ZM17.672.96v22.606H9.817V.96h7.855Z' />
);

export const viewBox = '0 0 25 25';
